import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

//@ts-ignore
Number.prototype.clamp = function(min, max) {
  //@ts-ignore
  return Math.min(Math.max(this, min), max);
};

if (window.process) {
  window.process.on('uncaughtException', function (error) {
      console.error(error.name);
      console.error(error.message);
      console.error(error.stack);
      console.error(error.cause);
      console.log(error);
  });
}

ReactDOM.render(<BrowserRouter>
    <App />
</BrowserRouter>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
